import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import {
  Button,
  Box,
  Grid,
  List,
  ListItem,
  ListItemText,
  Divider,
  Typography,
  IconButton,
} from "@material-ui/core";
import axios from "axios";
import { CloudDownload } from "@material-ui/icons";
import ListItemAvatar from '@material-ui/core/ListItemAvatar';
import Avatar from '@material-ui/core/Avatar';
import ImageIcon from '@material-ui/icons/Image';
const useStyles = makeStyles(() => ({
  root: {
    width: "100%",
    position: "relative",
    overflow: "auto",
  },
}));

const CMLabellingListing = ({ closeDialog, labellingDetails, labellingFilesChecked = [] }) => {
  const classes = useStyles();

  const handleDownload = async (filePath) => {
    const fileToDownload = await axios.post(
      "/generate-presigned-url",
      {
        s3_location: filePath,
      }
    );
    console.log(fileToDownload);
    window.open(fileToDownload.data.presigned_url);
  };

  return (
    <div style={{ minHeight: "300px" }}>
      <div style={{ fontWeight: "bold", display: "flex", justifyContent: "space-between" }}>

        <h3>Labelling Files Scanned</h3>
        <Button
          onClick={() => closeDialog(false)}
          variant="outlined"
          style={{ marginRight: "1rem" }}
        >
          Close
        </Button>
      </div>
      <Divider style={{ marginTop: "5px", marginBottom: "15px" }} />
      {/* <div>
        Labelling Details: {labellingDetails}
      </div> */}
      {/* <div style={{ marginBottom: "5px" }}>
        Labelling Files Scanned
      </div> */}
      <Grid container>
        <List className={classes.root}>
          {labellingFilesChecked.map((item, index) => (
            <>
              <ListItem
                key={`item-${index}`}
                onClick={() => handleDownload(item.file_path)}
                style={{
                  cursor: "pointer",
                }}
              >
                <ListItemAvatar>
                  <Avatar style={{
                    cursor: "pointer",
                    backgroundColor: item.labelling_found === "true" ? "green" : "red",

                  }}
                    tooltip={"Download"}
                  >
                    <CloudDownload
                    />
                  </Avatar>
                </ListItemAvatar>
                <ListItemText

                  primary={<span
                    style={{
                      fontWeight: item.labelling_found === "true" ? "bold" : "",
                      fontSize: '1.2rem'

                    }}
                  >{item.file_name}</span>}

                  secondary={item.labelling_found === "true" ? "File used for Labelling" : ""}

                />
              </ListItem>
              <Divider component="li" />
            </>

          ))}
        </List>
        {/* <Grid item sm={12} sx={{ mt: -2 }}>
          <Box display="flex" justifyContent="flex-end">
            <Button
              onClick={() => closeDialog(false)}
              variant="outlined"
              style={{ marginRight: "1rem" }}
            >
              Close
            </Button>
          </Box>
        </Grid> */}
      </Grid>
    </div>
  );
};
export default CMLabellingListing;
